export const recaptchaLogger = {
  error: (message, meta = {}) => {
    const hostname =
      typeof window !== 'undefined' ? window.location.hostname : '';
    const isProd = hostname === import.meta.env.VITE_PRD_HOST;
    if (!isProd) {
      console.error('[ReCaptcha] ERROR:', message, meta);
    }
  },
  warn: (message, meta = {}) => {
    const hostname =
      typeof window !== 'undefined' ? window.location.hostname : '';
    const isProd = hostname === import.meta.env.VITE_PRD_HOST;
    if (!isProd) {
      console.warn('[ReCaptcha] WARN:', message, meta);
    }
  },
  info: (message, meta = {}) => {
    const hostname =
      typeof window !== 'undefined' ? window.location.hostname : '';
    const isProd = hostname === import.meta.env.VITE_PRD_HOST;
    if (!isProd) {
      console.info('[ReCaptcha] INFO:', message, meta);
    }
  }
};

export default recaptchaLogger;
